module.exports = function (e) {
  var t = {};
  function a(n) {
    if (t[n]) return t[n].exports;
    var r = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(r.exports, r, r.exports, a), r.l = !0, r.exports;
  }
  return a.m = e, a.c = t, a.d = function (e, t, n) {
    a.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.t = function (e, t) {
    if (1 & t && (e = a(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (a.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) a.d(n, r, function (t) {
      return e[t];
    }.bind(null, r));
    return n;
  }, a.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(t, "a", t), t;
  }, a.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, a.p = "", a(a.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, a) {
  "use strict";

  a.r(t);
  var n = a(0),
    r = a.n(n);
  var l = function l(e) {
      return Array.isArray(e) && e.length > 0;
    },
    c = function c(e) {
      return l(e) ? e[e.length - 1] : {};
    },
    m = function m(e) {
      return e && e instanceof Date && !isNaN(e.getTime());
    },
    o = function o(e) {
      return m(e) ? String(e.getFullYear()) : "-";
    },
    i = r.a.memo(function (e) {
      return r.a.createElement("svg", {
        className: "rt-dot",
        viewBox: "0 0 8 10"
      }, r.a.createElement("circle", {
        cx: "4",
        cy: "5",
        r: "3",
        stroke: "none"
      }));
    }),
    u = r.a.memo(function (e) {
      return r.a.createElement("svg", {
        className: "rt-arrow",
        viewBox: "0 0 6 8"
      }, r.a.createElement("g", null, r.a.createElement("path", {
        d: "M 0 0 L 6 4 L 0 8 L 0 0"
      })));
    }),
    s = r.a.memo(function (e) {
      return r.a.createElement("div", {
        className: "rt-label"
      }, o(e.event.date));
    }),
    d = r.a.memo(function (e) {
      return r.a.createElement("div", {
        className: "rt-label"
      }, o(e.event.date));
    }),
    v = r.a.memo(function (e) {
      return r.a.createElement("div", null, r.a.createElement("h2", {
        className: "rt-title"
      }, e.event.title), r.a.createElement("p", {
        className: "rt-date"
      }, function (e) {
        if (!m(e)) return "-";
        var t = String(e.getDate()),
          a = String(e.getMonth() + 1),
          n = String(e.getFullYear());
        return "".concat(a.length > 1 ? a : "0" + a, "/").concat(t.length > 1 ? t : "0" + t, "/").concat(n);
      }(e.event.date)));
    }),
    f = r.a.memo(function (e) {
      return r.a.createElement("button", {
        className: "rt-btn",
        onClick: function onClick(t) {
          t.preventDefault(), (e.event.onClick || function (e) {
            return e;
          })(t);
        }
      }, e.event.buttonText || "");
    }),
    E = r.a.memo(function (e) {
      return r.a.createElement("div", null, r.a.createElement("p", null, e.event.text));
    }),
    g = r.a.memo(function (e) {
      return r.a.createElement("div", null, r.a.createElement("img", {
        src: e.event.imageUrl,
        className: "rt-image",
        alt: ""
      }));
    }),
    p = r.a.memo(function (e) {
      return r.a.createElement("div", {
        className: "rt-svg-container"
      }, r.a.createElement(u, null), r.a.createElement(i, null));
    }),
    b = r.a.memo(function (e) {
      return r.a.createElement("li", {
        key: "clear",
        className: "rt-clear"
      });
    }),
    y = r.a.memo(function (e) {
      var t = e.events,
        a = e.customComponents,
        n = e.reverseOrder,
        o = e.denseLayout,
        i = t.slice(0).filter(function (_ref) {
          var e = _ref.date;
          return m(e);
        }).sort(function (e, t) {
          return n ? new Date(t.date).getTime() - new Date(e.date).getTime() : new Date(e.date).getTime() - new Date(t.date).getTime();
        });
      if (!i.length) return r.a.createElement("div", null);
      var _ref2 = a || {},
        u = _ref2.topLabel,
        y = _ref2.bottomLabel,
        N = _ref2.header,
        x = _ref2.footer,
        h = _ref2.imageBody,
        S = _ref2.textBody,
        k = u || s,
        w = y || d,
        O = N || v,
        T = h || g,
        j = S || E,
        D = x || f,
        L = o ? {
          minHeight: "auto"
        } : {};
      return r.a.createElement("div", null, r.a.createElement("div", {
        className: "rt-timeline-container"
      }, r.a.createElement("ul", {
        className: "rt-timeline"
      }, r.a.createElement("li", {
        key: "top",
        className: "rt-label-container"
      }, r.a.createElement(k, {
        event: (M = i, l(M) ? M[0] : {})
      })), i.map(function (e, t) {
        return r.a.createElement("li", {
          className: "rt-event",
          key: t,
          style: L
        }, r.a.createElement("div", {
          className: "rt-backing"
        }, r.a.createElement(p, null), r.a.createElement("div", null, r.a.createElement("div", {
          className: "rt-header-container"
        }, r.a.createElement(O, {
          event: e
        })), r.a.createElement("div", {
          className: "rt-image-container"
        }, r.a.createElement(T, {
          event: e
        })), r.a.createElement("div", {
          className: "rt-text-container"
        }, r.a.createElement(j, {
          event: e
        })), r.a.createElement("div", {
          className: "rt-footer-container"
        }, r.a.createElement(D, {
          event: e
        })))));
      }), r.a.createElement(b, null), r.a.createElement("li", {
        key: "bottom",
        className: "rt-label-container"
      }, r.a.createElement(w, {
        event: c(i)
      })))));
      var M;
    });
  t.default = y;
}]);